import { useSDKConfigStore } from "../stores/sdkConfigStore";
import { getUserCards, updateCard } from "../api/api";
import { useCardStatusStore } from "../stores/cardStatusStore";
import { CreditProviderId } from "../config/creditRegistry";

export interface UpdateCardProviderParams {
  creditType: CreditProviderId;
  chainId: number;
  config?: {
    aTokenAddress?: string;
    vaultTokenAddress?: string;
    purchaseBaseTokenAddress: string;
  };
}

export async function updateCardProvider({
  creditType,
  chainId,
  config,
}: UpdateCardProviderParams): Promise<{ success: boolean; message: string }> {
  const { jwt } = useSDKConfigStore.getState();
  const { userCard, _setUserCard } = useCardStatusStore.getState();

  if (!jwt?.eoa) {
    return {
      success: false,
      message: "EOA address not found. Please initialize the SDK first.",
    };
  }

  if (!userCard?.cardID) {
    return {
      success: false,
      message: "No card found. Please create a card first.",
    };
  }

  try {
    console.log("[updateCardProvider] Step 1: Updating card provider...");
    const updateResult = await updateCard({
      creditProviderAddress: jwt.eoa,
      chainId,
      creditType,
      config,
      cardID: userCard.cardID,
    });

    if (!updateResult.success) {
      return {
        success: false,
        message: updateResult.message || "Failed to update card provider",
      };
    }

    console.log("[updateCardProvider] Step 2: Refetching updated data...");
    const userCardsResponse = await getUserCards();

    const initialUserCard = userCardsResponse.data?.[0] || null;
    _setUserCard(initialUserCard);
    console.log("[updateCardProvider] Card provider updated successfully.");
    return {
      success: true,
      message: "Card provider updated successfully.",
    };
  } catch (err) {
    const message =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    console.error("[updateCardProvider] Error during provider update:", err);
    return {
      success: false,
      message,
    };
  }
}
